import { styled } from "styled-components";

interface NavLinkStyleProps {
  $padding?: string;
  $fontWeight?: string;
  $fontSize?: string;
  $fontColor?: string;
  $bcgClr?: string;
  $positionCircle?: string;
  $circleColor?: string;
  $margin?: string;
  $borderRadius?: string;
}

const NavLinkStyle = styled.div<NavLinkStyleProps>`
     a {
    position: relative;
    padding: ${({$padding}) => $padding || "10px 15px"};
    text-decoration: none;
    font-weight: ${({$fontWeight}) => $fontWeight || "300"};
    font-size: ${({$fontSize}) => $fontSize || "19px"};
    color: ${({$fontColor}) => $fontColor || "#fff"};
    margin: ${({$margin}) => $margin};
    display: block;
    transition: 0.3s;
    border-radius: ${({ $borderRadius  }) => $borderRadius};
    &:hover, &.active{
    background-color: ${({ $bcgClr  }) => $bcgClr};
  }

    &::before {
      content: "";
      position: absolute;
      left: ${({$positionCircle}) => $positionCircle || "-4px"};; /* Position the circle to the left of the link */
      top: 50%;
      transform: translateY(-50%) translateX(-50%) scale(0); /* Initial state: no visible circle */
      background-color: transparent;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      transition: transform 0.3s ease-in-out, background-color 0.3s ease-in-out;
    }

    &:hover::before,
    &.active::before {
      background-color: ${({$circleColor}) => $circleColor || "#fff"};; /* Circle color when hovered or active */
      transform: translateY(-50%) translateX(-50%) scale(1); /* Visible circle */
    }
  }
`;

export default NavLinkStyle;